<template>
  <v-dialog :value="show" max-width="1200" scrollable @input="$emit('close')">
    <v-card v-if="log">
      <v-card-title class="d-flex align-center flex-wrap">
        <span class="mr-2">{{ log.operation }}</span>
        <v-chip
          small
          dark
          :color="httpMethodColor(log.httpMethod)"
          class="mr-2"
        >
          {{ log.httpMethod }}
        </v-chip>
        <v-icon :color="log.success ? 'success' : 'error'" class="mr-2">
          {{ log.success ? "check_circle" : "cancel" }}
        </v-icon>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-subtitle class="pt-1">
        <span>{{ log.createdAt }}</span>
        <span class="mx-1">·</span>
        <span :class="log.durationMs > 5000 ? 'red--text font-weight-bold' : ''">
          {{ log.durationMs }} ms
        </span>
        <span class="mx-1">·</span>
        <span>HTTP {{ log.responseCode }}</span>
        <span v-if="log.reference">
          <span class="mx-1">·</span>
          <span>{{ log.reference }}</span>
        </span>
      </v-card-subtitle>

      <v-card-text>
        <div v-if="log.errorMessage" class="mb-3">
          <v-alert type="error" dense>{{ log.errorMessage }}</v-alert>
        </div>

        <div class="mb-2">
          <strong>Endpoint:</strong> {{ log.endpoint || "—" }}
        </div>

        <v-row>
          <v-col cols="6">
            <div class="d-flex align-center justify-space-between mb-1">
              <strong>Request Body</strong>
              <v-btn small text @click="copyToClipboard(log.requestBody)">
                <v-icon small left>content_copy</v-icon>Copy
              </v-btn>
            </div>
            <pre class="body-pre">{{ formatBody(log.requestBody, log.httpMethod) }}</pre>
          </v-col>
          <v-col cols="6">
            <div class="d-flex align-center justify-space-between mb-1">
              <strong>Response Body</strong>
              <v-btn small text @click="copyToClipboard(log.responseBody)">
                <v-icon small left>content_copy</v-icon>Copy
              </v-btn>
            </div>
            <pre class="body-pre">{{ formatBody(log.responseBody, log.httpMethod) }}</pre>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ThirdPartyApiLogsDetail",

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    log: {
      type: Object,
      default: null,
    },
  },

  methods: {
    httpMethodColor(method) {
      const colors = { GET: "blue", POST: "orange", POST_XML: "purple" };
      return colors[method] || "grey";
    },

    formatBody(body, httpMethod) {
      if (!body) return "—";
      if (httpMethod === "POST_XML") return body;
      try {
        return JSON.stringify(JSON.parse(body), null, 2);
      } catch (e) {
        return body;
      }
    },

    copyToClipboard(text) {
      if (!text) return;
      navigator.clipboard.writeText(text).then(() => {
        this.$store.dispatch("showAppSnackbar", {
          msg: "Copied to clipboard",
          color: "success",
        });
      });
    },
  },
};
</script>

<style scoped>
.body-pre {
  background: #f5f5f5;
  padding: 8px;
  border-radius: 4px;
  overflow: auto;
  max-height: 400px;
  font-size: 12px;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/logs/ThirdPartyApiLogsDetail.vue